( function( $ ) {
	$( document ).ready( function() {
		$( '.modal' ).each( function() {
			var $modal = $( this );
			var $iframe = $( this ).find( 'iframe' );
			var src = $iframe.attr( 'src' );

			$modal.on( 'hide.bs.modal', function( ) {
				$iframe.attr( 'src', '' );
				$iframe.attr( 'src', src );
			} );
		} );
	} );
} )( jQuery );